import React, { Fragment, useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import Navbar from "../Navbar";
import Footer from "../Footer";
import Cookies from 'js-cookie';
import Modal from 'react-modal';

const { config } = require('../api/api');

Modal.setAppElement('#root');

const VisaPayment = () => {
  const base_url = config.baseURL;
  const { t } = useTranslation();

  const [pdata, setPdata] = useState({});
  // const [searchData, setSearchData] = useState(null);
  const [orderData, setOrderData] = useState(null);
  const [userData, setUserData] = useState(null);
  const [orderDetails, setOrderDetails] = useState(null);
  const [searchResult, setSearchResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [vendorKey, setVendorKey] = useState('');

  // ✅ Load SmartBox script
  useEffect(() => {
    const script = document.createElement("script");
    script.src = config.amwalpayURL;
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  // ✅ Load data from sessionStorage
  // useEffect(() => {
  //   // const storedSearch = sessionStorage.getItem('searchData');
  //   // if (storedSearch && storedSearch !== "undefined") {
  //   //   setSearchData(JSON.parse(storedSearch));
  //   // }

  //   const storedOrder = sessionStorage.getItem('event_data');
  //   if (storedOrder && storedOrder !== "undefined") {
  //     setOrderData(JSON.parse(storedOrder));
  //   }

  //   const storedOrderDetails = sessionStorage.getItem('order_data');
  //   if (storedOrderDetails && storedOrderDetails !== "undefined") {
  //     setOrderDetails(JSON.parse(storedOrderDetails));
  //   }

  //   const storedResult = sessionStorage.getItem('searchResult');
  //   if (storedResult && storedResult !== "undefined") {
  //     setSearchResult(JSON.parse(storedResult));
  //   }
  // }, []);

     const urlSearchString = window.location.search;

    const uparams = new URLSearchParams(urlSearchString);

        // useEffect(()=>{
        //     const order =uparams.get('orderid');
        //     // setOrder(order);
        // },[]);

            useEffect(() => {
        
                if (vendorKey && uparams.get('order_id')) {
                    setLoading(true);
                    var GivenData = {
                        'order_id': uparams.get('order_id'),
                        'vendor_key': vendorKey
                    }
        
                    var vkData = GivenData;
                    debugger
        
                    fetch(base_url+'/each_order_details', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(vkData),
                    })
                        .then(response => response.json())
                        .then(data => {
                            debugger
                            console.log(data.result.order)
        
                            setOrderDetails(data.result.order);
                        })
                        .catch(error => {
                            console.error('Error posting data:', error);
                        })
                        .finally(() => {
                            setLoading(false);
                          });
                }
            }, [ vendorKey, uparams.get('order_id')]);

  // ✅ Load userData
  useEffect(() => {
    const storedUserString = Cookies.get('userData');
    if (storedUserString) {
      setUserData(JSON.parse(storedUserString));
    } else {
      alert("Login session expired");
      window.location.href = '/';
    }
  }, []);

  // ✅ Create Vendor Key if missing
  useEffect(() => {
    if (!vendorKey) {
      const postvData = { organization_name: "Superjet" };

      fetch(`${base_url}/create_organization`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(postvData),
      })
        .then(res => res.json())
        .then(data => {
          if (data?.result?.[0]?.vendor_key) {
            setVendorKey(data.result[0].vendor_key);
          }
        })
        .catch(err => console.error('Error creating vendor:', err));
    }
  }, [vendorKey, base_url]);

  // ✅ Handle payment
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!userData?.access_token || !vendorKey || !orderDetails ) {
      alert("Missing required data. Please refresh and try again.");
      return;
    }

    setLoading(true);

    const referenceId = `${Math.floor(Math.random() * 90000000) + 10000000}`;

    const data = {
      order_id: orderDetails.order_id,
      amount_cents: orderDetails.fee,
      reference_id: referenceId,
      is_live: "true",
      // first_name: orderDetails.first_name,
      // last_name: orderDetails.last_name,
      // phone_no: orderDetails.phone_no,
      // apartment: orderDetails.apartment,
      // floor: orderDetails.floor,
      // street: orderDetails.street,
      // city: orderDetails.city,
      // state: orderDetails.state,
      // country: orderDetails.country,
      // email: orderDetails.email,
      save_selection: "true",
      redirection_url: `${base_url}/payment_intention_new`,
      currency: orderDetails.currency,
      fee_omr: orderDetails.fee_omr,
      description: "Visa Payment",
      vendor_key: vendorKey,
    };

    setPdata(data);

    try {
      const res = await fetch(`${base_url}/evisapayments`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${userData.access_token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      const result = await res.json();
      setLoading(false);

      if (result.message === "success") {
       var parsedata = JSON.parse(result.result.payment_details)
        const { secureHash, trxParams } = parsedata;

        window.SmartBox.Checkout.configure = {
          MID: trxParams.MerchantId,
          TID: trxParams.TerminalId,
          CurrencyId: trxParams.CurrencyId,
          AmountTrxn: trxParams.Amount,
          MerchantReference: trxParams.MerchantReference,
          LanguageId: "en",
          PaymentViewType: 1, // Popup
          TrxDateTime: trxParams.TrxDateTime,
          SessionToken: trxParams.SessionToken,
          SecureHash: secureHash,
          completeCallback: async (data) => {
            setLoading(true);
            try {
              const verifyRes = await axios.post(`${base_url}/evisapaymentsupdate`, data.data);
              if (verifyRes.data.valid) {
                window.location.href = verifyRes.data.data;
              }
            } catch (err) {
              console.error("Verification failed:", err);
            }
          },
          errorCallback: (error) => {
            setLoading(true);
             window.location.href = `${config.redirectURL}/order-failed`;
            console.error("Payment error:", error);
          },
         cancelCallback: (cancel) => {
          console.log("⚠️ Payment cancelled:",cancel );
        },
        };

        window.SmartBox.Checkout.showSmartBox();
      }
    } catch (err) {
      setLoading(false);
      console.error("Error creating payment intention:", err);
    }
  };

  return (
    <Fragment>
      <div className="header_section1">
        <Navbar />
        <div className="container-fluid bg-breadcrumb">
          <div className="container text-center py-5">
            <h3 className="abt-txt my-5">{t('Make Payment')}</h3>
          </div>
        </div>
      </div>

      <div className="features_section">
        <div className="container">
          <Row>
            <Col md={3}></Col>
            <Col md={6} className="myforms my-5">
              <div className="clformrow mt-1">
                <div className="input-group mb-2 mt-2">
                  <div className="input-group-prepend prepends">
                    <span className="input-group-text">{t('First')} {t('Name')}</span>
                  </div>
                  <input type="text" className="form-control" value={orderDetails?.first_name || ""} readOnly />
                </div>

                <div className="input-group mb-2 mt-2">
                  <div className="input-group-prepend prepends">
                    <span className="input-group-text">{t('Last')} {t('Name')}</span>
                  </div>
                  <input type="text" className="form-control" value={orderDetails?.last_name || ""} readOnly />
                </div>

                <div className="input-group mb-2 mt-2">
                  <div className="input-group-prepend prepends">
                    <span className="input-group-text">{t('Email')}</span>
                  </div>
                  <input type="text" className="form-control" value={orderDetails?.email || ""} readOnly />
                </div>

                <div className="input-group mb-2 mt-2">
                  <div className="input-group-prepend prepends">
                    <span className="input-group-text">{t('Passport')} {t('Country')}</span>
                  </div>
                  <input type="text" className="form-control" value={orderDetails?.arrival || ""} readOnly />
                </div>

                <div className="input-group mb-2 mt-2">
                  <div className="input-group-prepend prepends">
                    <span className="input-group-text">{t('Destination')} {t('Country')}</span>
                  </div>
                  <input type="text" className="form-control" value={orderDetails?.destination || ""} readOnly />
                </div>

                <div className="input-group mb-2 mt-2">
                  <div className="input-group-prepend prepends">
                    <span className="input-group-text">{t('Fee')}</span>
                  </div>
                  <input type="text" className="form-control" value={orderDetails?.fee || ""} readOnly />
                </div>

                <div className="input-group mb-2 mt-2">
                  <div className="input-group-prepend prepends">
                    <span className="input-group-text">{t('Currency')}</span>
                  </div>
                  <input type="text" className="form-control" value={orderDetails?.currency || ""} readOnly />
                </div>

                 <div className="input-group mb-2 mt-2">
                  <div className="input-group-prepend prepends">
                    <span className="input-group-text">{t('Fee')}{' (OMR)'}</span>
                  </div>
                  <input type="text" className="form-control" value={orderDetails?.fee_omr? orderDetails?.fee_omr+" OMR":""} readOnly />
                </div>

                <button
                  type="button"
                  onClick={handleSubmit}
                  className="btn btn-primary rounded-pill text-white my-3 py-1 px-4"
                  disabled={loading}
                >
                  {loading ? t('Processing...') : t('Make Payment')}
                </button>
              </div>
            </Col>
            <Col md={3}></Col>
          </Row>

          {loading && (
            <div className="overlay">
              <div className="spinner"></div>
            </div>
          )}
        </div>
      </div>

      <Footer />
    </Fragment>
  );
};

export default VisaPayment;
